// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".details[data-v-ca621d58] {\n  padding: 1rem 0 0;\n}\n.details__title[data-v-ca621d58] {\n  cursor: pointer;\n  font-size: 1.7rem;\n}\n.details__caret[data-v-ca621d58] {\n  display: inline-block;\n  width: 1.5rem;\n}\n.details__list[data-v-ca621d58] {\n  height: 0;\n  margin: 0;\n  overflow: hidden;\n}\n.details__list--open[data-v-ca621d58] {\n  margin: 0.5rem 0 0 2rem;\n  height: auto;\n}", ""]);
// Exports
module.exports = exports;
